module.exports = "/images/vendor/desiigner-svg/svg/logoipsum/logoipsum-5.svg?b1ce64e8af31637929f905cd45c19954";